const ThreeStars = ({ className }: { className: string }) => (
	<div>
		{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
		<svg className={className} data-name="Layer 1" viewBox="153.9 114.5 395.5 500.8" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M240.12 615.26a4.81 4.81 0 0 1-4.81-4.65L226.44 361a4.82 4.82 0 1 1 9.63-.34l8.87 249.62a4.83 4.83 0 0 1-4.65 5Z"
				fill="#f6e9d0"
			/>
			<path
				d="M308.81 553.1a4.8 4.8 0 0 1-2.33-.61A819.82 819.82 0 0 1 155.6 445.16 4.82 4.82 0 0 1 162 438a809.83 809.83 0 0 0 149.1 106.08 4.82 4.82 0 0 1-2.33 9Z"
				fill="#f6e9d0"
			/>
			<path
				d="M162.94 575.08a4.82 4.82 0 0 1-3.26-8.36A4638.96 4638.96 0 0 0 283.8 447.93a4.82 4.82 0 1 1 6.79 6.84 4594.38 4594.38 0 0 1-124.38 119 4.83 4.83 0 0 1-3.27 1.31ZM478.59 355.11a4.83 4.83 0 0 1-4.77-4.16C465.92 294 460.25 236.09 457 178.73a4.82 4.82 0 1 1 9.62-.56 2146.5 2146.5 0 0 0 16.8 171.46 4.82 4.82 0 0 1-4.11 5.43 5.16 5.16 0 0 1-.72.05Z"
				fill="#f6e9d0"
			/>
			<path
				d="M544.07 294a4.79 4.79 0 0 1-2.4-.65 558.81 558.81 0 0 0-128.16-54 4.82 4.82 0 0 1 2.6-9.28A568 568 0 0 1 546.49 285a4.82 4.82 0 0 1-2.42 9Z"
				fill="#f6e9d0"
			/>
			<path
				d="M402.28 320.81a4.82 4.82 0 0 1-3.28-8.31l92.6-88.13a4.82 4.82 0 0 1 6.64 7l-92.6 88.13a4.77 4.77 0 0 1-3.36 1.31ZM229 249.74a4.82 4.82 0 0 1-4.77-4.23 797.93 797.93 0 0 1-5.65-126.39 4.82 4.82 0 0 1 9.63.34 788.24 788.24 0 0 0 5.58 124.86 4.83 4.83 0 0 1-4.19 5.38c-.16.02-.36.04-.6.04Z"
				fill="#f6e9d0"
			/>
			<path
				d="M283.78 206.61a4.72 4.72 0 0 1-2.54-.73A742.64 742.64 0 0 0 173 150.31a4.82 4.82 0 1 1 3.68-8.9 751 751 0 0 1 109.65 56.29 4.82 4.82 0 0 1-2.55 8.91Z"
				fill="#f6e9d0"
			/>
			<path
				d="M178.8 231.88a4.81 4.81 0 0 1-3.88-7.67 437.41 437.41 0 0 1 92-92.33 4.82 4.82 0 0 1 5.74 7.74 427.69 427.69 0 0 0-90 90.3 4.8 4.8 0 0 1-3.86 1.96Z"
				fill="#f6e9d0"
			/>
		</svg>
	</div>
)
export default ThreeStars
